/* eslint-disable no-console */
/* eslint-disable no-undef */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
import { Container, Grid } from "@mui/material";
import MKBox from "components/MKBox";
import React, { useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";
import { saveAs } from "file-saver";

import "./pdf.css";
import counterDocuments from "API/counterDocuments";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

export default function ReadPDF({ pdf, name }) {
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1);
  const [documentName] = useState({ name });

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const zoomIn = () => {
    setScale(scale - 0.5);
  };
  const zoomOut = () => {
    setScale(scale + 0.5);
  };

  // save file
  const saveFile = () => {
    saveAs(`${pdf}`, `${name}.pdf`);
    // counter
    counterDocuments({ documentName });
  };

  return (
    <>
      <Container
        style={{ backgroundColor: "#323639", boxShadow: "0px 0px 0px 1px #525659", height: "60px" }}
      >
        <Grid container style={{ backgroundColor: "#323639", height: "55px" }}>
          <MKBox position="absolute" style={{ marginLeft: "40%" }}>
            <button onClick={zoomIn} className="buttonPDF">
              <span className="material-icons" style={{ color: "#fff" }}>
                remove
              </span>
            </button>
          </MKBox>
          <MKBox position="absolute" style={{ marginLeft: "45%", marginTop: "1.5%" }}>
            <input
              type="text"
              name="xoom"
              className="inputValue"
              value={`${scale * 100}%`}
              readOnly
            />
          </MKBox>
          <MKBox position="absolute" style={{ marginLeft: "51%" }}>
            <button onClick={zoomOut} className="buttonPDF">
              <span className="material-icons" style={{ color: "#fff" }}>
                add
              </span>
            </button>
          </MKBox>
          <MKBox style={{ marginLeft: "95%" }}>
            <button onClick={saveFile} className="buttonPDF">
              <span className="material-icons" style={{ color: "#fff" }}>
                download
              </span>
            </button>
          </MKBox>
        </Grid>
      </Container>
      <div className="all-page-container">
        <Document file={pdf} onLoadSuccess={onDocumentLoadSuccess}>
          {Array.from(new Array(numPages), (el, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={scale} />
          ))}
        </Document>
      </div>
    </>
  );
}
